import React from 'react'

import {
    WideScreenContainer
} from 'components/elements'

import PurpleAnimHeader from 'components/PurpleAnimHeader';
// import ViewAll from 'components/ViewAll';

// import {r3cPageContent} from 'constants/index'
import NewsletterSignup from 'components/NewsletterSignup';
// import {findContent, getImageDimensions, isEmptyObject} from 'generalHelpers'

import FooterAnimation from 'components/FooterAnimation'
import LearnAboutOtherNewsletters from 'components/LearnAboutOtherNewsletters';
import { NewslettersPageWrap } from '../elements';
// import useRememberScrollPosition from 'hooks/useRememberScrollPosition';
import LoadingHoc from 'hoc/LoadingHOC';




function HealthEquitySignup(props) {

	const {setLoading} = props		 //receive the loading trigger change function from the HOC


	React.useEffect(() => {
			setLoading(false)

		// eslint-disable-next-line
	}, [])



	// useRememberScrollPosition('health-equity-digest')
	
	return (
		<NewslettersPageWrap className="pageWrapper">

			<PurpleAnimHeader
                sectionLabel={"Health Equity Digest"}
                sectionTitle={undefined}
				heroIntro={undefined}
				headerSplit={"1"}
                backgroundImage={"/images/health-equity-header-dsktop.png"}
				backgroundImgMbl={"/images/health-equity-header-mbl.png"}
				backgroundImgTitle={""}
                header={"Together, we are always better"}
				introCopy={"We’ve set out to create a world where every human has the opportunity for an excellent healthcare experience. Every. Human. Period. No exceptions. "}
                titleMdPadding={"15% 0 0"}
				maxWidth={"30%"}
				marginRight={"10%"}
				maxHeight="650px"
				headerMaxWidth="50%"
            />


			<WideScreenContainer>
				<NewsletterSignup
				phoneDesktop={"/images/health-equity-phone.png"}
				phoneMobile={"/images/health-equity-phone.png"}
				pardotLink={"https://go.realchemistry.com/l/603341/2022-11-10/68xhf"}

				/>
			  <LearnAboutOtherNewsletters
				  monthly={true}
				  healthEquity={false}
				  valueReport={true}
				  displayHeader={true}

				/>

			</WideScreenContainer>
		


			<FooterAnimation
				svgDesktop="/images/purple-footer.svg"
				svgMobile="/images/purple-footer-mbl.svg"
				borderTop="none"
			/>
		</NewslettersPageWrap>
	)
}


export default LoadingHoc(HealthEquitySignup);
